// @flow

import * as React from 'react';
import { localize, unescaped } from '@ta/common.i18n';
import { Link } from '@ta/common.routing';
import { ClickTracker } from '@ta/common.tracking';
import type { SimpleLink } from './SimpleLinkSection';
import styles from './Legal.less';

export type LegalData = {
  miscLinks: SimpleLink[],
  /** This determines whether we need to show special legal text for a media vendor (VFM Leonardo) */
  showVfmText: boolean,
  showDisclaimerText: boolean,
};

type Props = {
  legalData: LegalData,
};

type State = {|
  disclaimerExpanded: boolean,
|};

const currentYear = new Date().getFullYear();

/**
 * Legal text and links for footer.
 */
class Legal extends React.Component<Props, State> {
  state = {
    disclaimerExpanded: false,
  };

  expandDisclaimer = () => {
    this.setState({
      disclaimerExpanded: true,
    });
  };

  disclaimerTextChunk() {
    if (this.state.disclaimerExpanded) {
      // Show the entire disclaimer text
      return (
        <span className="is-hidden-mobile">
          {unescaped(localize('footer_disclaimer_full_text_v3'))}
        </span>
      );
    }

    // Show a small portion of disclaimer text
    return (
      <div className="is-hidden-mobile">
        {localize('footer_26ed')}{' '}
        {/* TripAdvisor LLC is not a booking agent and does not charge any service fees to users of our site... */}
        <span id="TERMS" className={`ui_link ${styles.expandLink}`} onClick={this.expandDisclaimer}>
          {localize('common_more_ffffe87d')}
        </span>
      </div>
    );
  }

  handleJsClick = (e: SyntheticEvent<*>, link: SimpleLink) => {
    e.persist();
    if (link.idForJS === 'cookie-consent') {
      __non_webpack_require__(['trjs!ta/popups/CookieSettingsPanel'], module => module());
    }
  };

  render() {
    return (
      <div className={styles.container}>
        {localize('common_26ec', {
          '0': currentYear,
        })}{' '}
        {localize('common_Allrightsreserved')}
        <div className={styles.miscLinksContainer}>
          {this.props.legalData.miscLinks.map((link, index) => (
            <span key={link.url}>
              {index > 0 ? ' | ' : ''}
              <ClickTracker module="Footer" action="click" context={link.trackAction} useSpan>
                {link.idForJS ? (
                  <span
                    onClick={e => this.handleJsClick(e, link)}
                    className={`ui_link ${styles.miscLink}`}
                  >
                    {link.text}
                  </span>
                ) : (
                  <Link
                    href={link.url}
                    className={`ui_link ${styles.miscLink}`}
                    target={link.newWindow ? '_blank' : undefined}
                  >
                    {link.text}
                  </Link>
                )}
              </ClickTracker>
            </span>
          ))}
        </div>
        {this.props.legalData.showVfmText ? (
          <div>{localize('photos_provided_by_2_1bed', { '0': 'VFM Leonardo' })}</div>
        ) : (
          ''
        )}
        {this.props.legalData.showDisclaimerText ? this.disclaimerTextChunk() : null}
        <div className="is-hidden-mobile">{localize('footer_extended_248')}</div>
        {/* TripAdvisor LLC is not responsible for content on external web sites. */}
      </div>
    );
  }
}

export default Legal;
